import React from 'react'
import { Box, Button, CircularProgress, Typography } from '@mui/material'

export const Loader = () => (
    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
      <CircularProgress />
    </Box>
  );

export const Error = ({refetch, message}: {refetch?: () => void; message?: string}) => (
  <Box display="flex" justifyContent="center" alignItems="center" height="50vh" flexDirection="column">
      <Typography color="error">{message || 'Failed to load data.'}</Typography>
      {refetch && <Button onClick={refetch}>Retry</Button>}
    </Box>
)